module.exports = __webpack_public_path__ + "static/img/homepage-logo.4823994.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homepage-logo.png
// module id = /ztE
// module chunks = 9